// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
// api
import * as rms from './api/rms'



// thunks
export const fetchPublisherRevenueForOverview = createAsyncThunk('fetchPublisherRevenueForOverview', async requestData => {
    const response = await rms.postPublisherRevenueRequest(requestData);
    return response.data
});

export const fetchPublisherRevenueForStackedCharts = createAsyncThunk('fetchPublisherRevenueForStackedCharts', async requestData => {
    const response = await rms.postPublisherRevenueRequest(requestData);
    return response.data
});

export const fetchPublisherPageviewForStackedCharts = createAsyncThunk('fetchPublisherPageviewForOverview', async requestData => {
    const response = await rms.postPageviewRequest(requestData);
    return response.data
})